export enum ProductType {
  Car = 'car',
  Home = 'home',
}

export const YouSetProductTypes = [ProductType.Car, ProductType.Home];
